/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import axios from '@/api';

function qrScan(minor_id, institute_id) {
  return axios.post('tutor/qr/scan', {
      minor_id,
      institute_id,
    })
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function getAbsences(minor_id, classroom_id) {
  return axios.get(`tutor/absences/minor/${minor_id}/classroom/${classroom_id}`)
    .then(response => response)
    .catch(error => Promise.reject(error));
}

function setScheduledAbsence(id, classroom, absenceData) {
  const data = {
    reason: 'assenza',
    dateFrom: absenceData.dateFrom,
    dateTo: absenceData.dateTo,
  };
  return axios.post(`tutor/absence/minor/${id}/classroom/${classroom}/schedule`, data)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function removeAbsence(id) {
  return axios.delete(`tutor/absence/${id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

export const minorService = {
  qrScan,
  getAbsences,
  setScheduledAbsence,
  removeAbsence,
};
